
import Alert from "@util/alert.js";

export default{
    blurModifyCount(currentDom, addEl, reduceEl, model, count, option={oid:undefined,item:null}){
        let maxCount = model.getMaxBuyCount(option.item);
        let val = $(currentDom).val();
        if(isNaN(val)){
            $(currentDom).val(count);
            return;
        }
        if(val > maxCount){
            Alert.showTip(`该商品您最多只能购买${maxCount}个`);
            $(currentDom).val(count);
            return;
        }
        if(val <= 0 || val == count){
            $(currentDom).val(count);
            return;
        }
        model.modifyCount(val, option.oid).then(() => {
            if (val < maxCount) {
                addEl.removeAttr("disabled");
            }else{
                addEl.attr("disabled", true);
            }
            if(val == 1){
                reduceEl.attr("disabled", true);
            }else{
                reduceEl.removeAttr("disabled");
            }
        }).catch(err => { 
            Alert.showTip(err);
        });
    }
}